import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLStatusKeys } from "Api/Queries/Merchants/useGetOrbitLStatusQuery";
import {
  type ConfirmOrbitLHandoverResult,
  postMerchantsPublicIDOrbitLConfirmHandover,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export type { ConfirmOrbitLHandoverResult };

type Parameters = {
  merchantPublicID: string;
};

type Props = {
  onSuccess?: (data: ConfirmOrbitLHandoverResult) => void;
  onError?: () => void;
};

export const useConfirmOrbitLHandoverMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID }: Parameters) =>
        postMerchantsPublicIDOrbitLConfirmHandover(merchantPublicID),
    ),
    onSuccess: (
      data: ConfirmOrbitLHandoverResult,
      { merchantPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey: orbitLStatusKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
